module.exports = __webpack_public_path__ + "static/media/reduced-inequalities.41ff6d82.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/reduced-inequalities.png
// module id = 575
// module chunks = 0